<template>
  <div class="report">
    <div class="container">
      <div v-if="noData != null && noData" class="no-report-div">
        <p class="no-report">Nessun report configurato, contatta l'assistenza clienti.</p>
      </div>
      <template v-else>
        <filters-report :settings="settings" @get-report-data="getReportData" @no-report-found="noReportFound"></filters-report>
        <div id="report-datatable" class="row">
          <div v-if="getData" class="col-md-12">
            <datatable :key="getData" :settings="reportInfo" :get-data="getData"></datatable>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import FiltersReport from '@/components/Filters/Report.vue';
  import Datatable from '@/components/ReportDatatable.vue';
  
  export default {
    name: "reports",

    components: {FiltersReport, Datatable},   
    
    data() {
      return {
        noData: null,
        settings: {
          reportAttributes: { //Obbligatorio
            columns: {value: 'col-lg-12'},
            classes: {value: 'form-control'},
            options: {value: []},
            idField: {value: 'reportName'},
            labelField: {value: 'description'},
            required: {value: true},
            value: {value: null}
          },
          lowerboundAttributes: {
            columns: {value: 'col-lg-12'},
            classes: {value: 'form-control form-datepicker'},
            label: {value: 'Da'},
            placeholder: {value: 'Seleziona una data'},
            required: {value: false},
            dateFormat: {value: 'DD/MM/YYYY LT'},
            disabled: {value: false},
            value: {value: null}
          },
          upperboundAttributes: {
            columns: {value: 'col-lg-12'},
            classes: {value: 'form-control form-datepicker'},
            label: {value: 'A'},
            placeholder: {value: 'Seleziona una data'},
            required: {value: false},
            dateFormat: {value: 'DD/MM/YYYY LT'},
            disabled: {value: false},
            value: {value: null}
          }
        },
        getData: null,
        reportInfo: null
      }
    },

    methods: {
      getReportData(reportInfo) {
        this.reportInfo = reportInfo;
        this.getData = (((1+Math.random())*0x10000)|0).toString(16).substring(1);

        this.$scrollTo('#report-datatable', {offset: -20});
      },

      noReportFound() {
        this.noData = true;
      }
    }
  };
</script>

<style>
.no-report-div {
  margin-top: 10%;
}
.no-report {
  text-align: center;
  font-size: 25px;
}
</style>